import React, { useState, useEffect, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "../DocSum/style.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const SumPdfViewer = ({ src, highlightText, onHighlightPosition, endIndex }) => {
  const [pdfFile, setPdfFile] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [textList, setTextList] = useState([]);
  const [highlights, setHighlights] = useState([]);
  const pdfPages = useRef([]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setTextList([]);
    setHighlights([]);
  };

  const handlePageLoadSuccess = async (pageIndex, pdfPage) => {
    pdfPages.current[pageIndex] = pdfPage;
    console.log(pdfPages, 'pdfPages')
    const textContent = await pdfPage.getTextContent();
    console.log(textContent, 'textContent')
    const newTextList = textContent.items.map((item) => ({
      text: item.str,
      transform: item.transform,
      width: item.width,
      height: item.height,
      pageIndex,
    }));
    console.log(newTextList, 'newTextList')
    setTextList((prev) => [...prev, ...newTextList]);
  };

  useEffect(() => {
    if (highlightText) {
      handleHighlight(highlightText);
    }
  }, [highlightText]);

  const handleHighlight = (textToHighlight) => {
    const highlightRects = [];
    textList.forEach((item) => {
        console.log(textList, 'textList')
      if (item.text === textToHighlight) {
        const pageIndex = item.pageIndex;
        const pdfPage = pdfPages.current[pageIndex];
        const viewport = pdfPage.getViewport({ scale: 1 });
        const [x, y, , , tx, ty] = item.transform;
        const highlightId = `highlight-${pageIndex}-${tx}-${ty}-End`;

        highlightRects.push({
          id: highlightId,
        //   id: `${endIndex}-End`,
          pageIndex,
          left: tx * viewport.scale - 2,
          top: (viewport.height - ty) * viewport.scale + 5,
          width: item.width * viewport.scale + 4,
          height: item.height * viewport.scale + 4,
          text: textToHighlight,
        });
        onHighlightPosition(highlightId);
      }
    });
    setHighlights(highlightRects);
  };

  return (
    <div style={{ background: '#aeb9d53d' }}>
      {src ? (
        <Document file={src} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.from(new Array(numPages), (el, index) => (
            <div key={`page_container_${index}`} style={{ position: "relative" }}>
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                scale={0.92}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                onLoadSuccess={(pdfPage) => handlePageLoadSuccess(index, pdfPage)}
              />
              {highlights
                .filter((hl) => hl.pageIndex === index)
                .map((rect, i) => (
                  <div
                    id={rect.id}
                    // key={rect.id}
                    key={`highlight_${i}`}
                    className="highlight"
                    style={{
                      position: "absolute",
                      left: `${rect.left}px`,
                      top: `${rect.top}px`,
                      width: `${rect.width}px`,
                      height: `${rect.height}px`,
                      border: "1.5px dashed rgb(0, 145, 255)",
                      pointerEvents: "none",
                    }}
                  ></div>
                ))}
            </div>
          ))}
        </Document>
      ) : (
        <p>No PDF file selected</p>
      )}
    </div>
  );
};

export default SumPdfViewer;


// import React, { useState, useEffect, useRef } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import "./pdfStyle.css";

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// const PdfViewer = ({ src, onBoundingBoxTextExtracted }) => {
//   const [numPages, setNumPages] = useState(null);
//   const [textItems, setTextItems] = useState([]); // Store text with bounding box
//   const [isDrawing, setIsDrawing] = useState(false);
//   const [boundingBox, setBoundingBox] = useState(null); // Store the coordinates of the bounding box
//   const pdfPages = useRef([]);
//   const viewerRef = useRef(null);

//   const onDocumentLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages);
//     setTextItems([]);
//   };

//   const handlePageLoadSuccess = async (pageIndex, pdfPage) => {
//     const textContent = await pdfPage.getTextContent();
//     const viewport = pdfPage.getViewport({ scale: 1 });
  
//     const extractedTextItems = textContent.items.map((item) => {
//       const [x, y, , , tx, ty] = item.transform;
  
//       return {
//         text: item.str,
//         left: tx * viewport.scale,
//         top: (viewport.height - ty) * viewport.scale,
//         width: item.width * viewport.scale,
//         height: item.height * viewport.scale,
//         pageIndex,
//       };
//     });
  
//     setTextItems((prev) => [...prev, ...extractedTextItems]);
//   };
  
  

//   const handleMouseDown = (e) => {
//     if (viewerRef.current) {
//       const rect = viewerRef.current.getBoundingClientRect();
//       const startX = e.clientX - rect.left;
//       const startY = e.clientY - rect.top;

//       setBoundingBox({ x1: startX, y1: startY, x2: startX, y2: startY });
//       setIsDrawing(true);
//     }
//   };

//   const handleMouseMove = (e) => {
//     if (isDrawing && viewerRef.current) {
//       const rect = viewerRef.current.getBoundingClientRect();
//       const currentX = e.clientX - rect.left;
//       const currentY = e.clientY - rect.top;

//       setBoundingBox((prev) => ({
//         ...prev,
//         x2: currentX,
//         y2: currentY,
//       }));
//     }
//   };

//   const handleMouseUp = () => {
//     if (isDrawing) {
//       setIsDrawing(false);
  
//       // Adjust the bounding box for slight mismatches
//       const adjustedBox = adjustBoundingBox(boundingBox);
  
//       // Extract the text from the adjusted bounding box
//       const extractedText = extractTextWithinBoundingBox(adjustedBox);
  
//       // Log or use the extracted text
//       console.log("Extracted Text:", extractedText);
  
//       // Optionally, you can clear the bounding box after use
//       setBoundingBox(null);
//     }
//   };
  
  

//   const extractTextWithinBoundingBox = () => {
//     if (!boundingBox || textItems.length === 0) return;
  
//     const { x1, y1, x2, y2 } = boundingBox;
//     const startX = Math.min(x1, x2);
//     const endX = Math.max(x1, x2);
//     const startY = Math.min(y1, y2);
//     const endY = Math.max(y1, y2);
  
//     // Match text items within the bounding box, allowing slight tolerance
//     const tolerance = 2; // Adjust this as needed
//     const matchedText = textItems.filter((item) => {
//       const itemRight = item.left + item.width;
//       const itemBottom = item.top + item.height;
  
//       return (
//         item.left >= startX - tolerance &&
//         itemRight <= endX + tolerance &&
//         item.top >= startY - tolerance &&
//         itemBottom <= endY + tolerance
//       );
//     });
  
//     console.log("Extracted Text:", matchedText.map((item) => item.text).join(" "));
//     return matchedText.map((item) => item.text).join(" ");
//   };

//   const adjustBoundingBox = (box) => {
//     const adjustmentFactor = 10; // Adjust as needed
//     return {
//       x1: box.x1 - adjustmentFactor,
//       y1: box.y1 - adjustmentFactor,
//       x2: box.x2 + adjustmentFactor,
//       y2: box.y2 + adjustmentFactor,
//     };
//   };


//   return (
//     <div
//       ref={viewerRef}
//       style={{
//         position: "relative",
//         background: "#f0f0f0",
//         padding: "10px",
//         userSelect: "none",
//       }}
//       onMouseDown={handleMouseDown}
//       onMouseMove={handleMouseMove}
//       onMouseUp={handleMouseUp}
//     >
//       {src ? (
//         <Document file={src} onLoadSuccess={onDocumentLoadSuccess}>
//           {Array.from(new Array(numPages), (el, index) => (
//             <div key={`page-container-${index}`} style={{ position: "relative" }}>
//               <Page
//                 key={`page-${index + 1}`}
//                 pageNumber={index + 1}
//                 renderTextLayer={false}
//                 renderAnnotationLayer={false}
//                 onLoadSuccess={(pdfPage) => handlePageLoadSuccess(index, pdfPage)}
//               />
//             </div>
//           ))}
//         </Document>
//       ) : (
//         <p>No PDF file selected</p>
//       )}

//       {/* Render the bounding box */}
//       {boundingBox && (
//         <div
//           style={{
//             position: "absolute",
//             left: `${Math.min(boundingBox.x1, boundingBox.x2)}px`,
//             top: `${Math.min(boundingBox.y1, boundingBox.y2)}px`,
//             width: `${Math.abs(boundingBox.x2 - boundingBox.x1)}px`,
//             height: `${Math.abs(boundingBox.y2 - boundingBox.y1)}px`,
//             border: "2px dashed rgba(255, 0, 0, 0.8)",
//             backgroundColor: "rgba(255, 0, 0, 0.2)",
//           }}
//         ></div>
//       )}
//     </div>
//   );
// };

// export default PdfViewer;

